import { useEffect } from "react";
import { useDebugMode } from "../../../../components/DebugMode/hooks/useDebugMode.ts";
import { scrollToEditionHistoryStore } from "../../../stores/scrollToEditionHistoryStore.ts";
import { SelectedAssetActions } from "../components/SelectedAssetActions.tsx";
import { ASSET_LAYER_TYPE } from "../Designer/constants.ts";
import { useSelectedLayerType } from "../Designer/hooks/useSelectedLayerType.ts";
import { CanvasSettingsSection } from "./components/CanvasSettingsSection.tsx";
import { DebugSection } from "./components/DebugSection.tsx";
import { EditionHistorySection } from "./components/EditionHistorySection.tsx";
import { LayersAlignmentSection } from "./components/LayersSection/LayersAligmentSection.tsx";
import { LayersHierarchySection } from "./components/LayersSection/LayersHierarchySection.tsx";

export const EditAssetDetailsPanel = () => {
  const selectedLayerType = useSelectedLayerType();

  const { scrollTrigger: scrollToEditionHistoryTrigger } =
    scrollToEditionHistoryStore.useState();

  useEffect(() => {
    if (
      scrollToEditionHistoryTrigger &&
      document.getElementById("edition-history")
    ) {
      setTimeout(() => {
        const element = document.getElementById("edition-history");
        if (element) {
          const rect = element.getBoundingClientRect();
          const isInView = rect.top >= 0 && rect.bottom <= window.innerHeight;

          if (!isInView) {
            element.scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
          }
        }
      }, 500);
    }
  }, [scrollToEditionHistoryTrigger]);

  const isDebugModeOn = useDebugMode();

  return (
    <div className="h-full flex-col divide-y-025">
      <SelectedAssetActions />
      <div className="flex-fill flex-col divide-y-025 overflow-y-auto">
        <CanvasSettingsSection />
        <LayersHierarchySection />
        <LayersAlignmentSection />
        {selectedLayerType === ASSET_LAYER_TYPE ? (
          <>
            <div id="edition-history" className="w-full">
              <EditionHistorySection />
            </div>
            {isDebugModeOn && <DebugSection />}
          </>
        ) : null}
      </div>
    </div>
  );
};
